var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-button',{staticClass:"history ml-5",attrs:{"disabled":_vm.disabled,"height":'25px',"text":_vm.editMode.text,"color":_vm.editMode.color,"customStyle":{
    'border-radius': '4px',
  },"margin":"1px 0px 0px 0px"},on:{"click":_vm.clickButton}},[(_vm.editMode.icon)?_c('v-icon',{staticClass:"mr-1",attrs:{"size":"18"}},[_vm._v(" mdi-pencil ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }